import * as React from 'react';
import { useTranslation } from 'react-i18next';
import ModalWithAction from 'Shared/Modal/ModalWithAction';

import styles from './confirmation-modal.module.css';

interface ConfirmationModalProps {
    children?: React.ReactElement | React.ReactElement[];
    header: string;
    onCancel: () => void;
    onConfirm: () => void;
    disableButton?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    header,
    children,
    onCancel,
    onConfirm,
    disableButton = false,
}) => {
    const { t } = useTranslation(['buttons']);

    return (
        <ModalWithAction
            header={header}
            actionText={t('buttons:confirm')}
            disable={disableButton}
            actionCallback={onConfirm}
            cancelCallback={onCancel}
            // Without a ceiling the dialog grows to whatever a paragraph measures, which reads poorly
            modalWidth={{ maxWidth: '34rem' }}
        >
            <div className={styles.ConfirmationModalContent}>{children}</div>
        </ModalWithAction>
    );
};

export default ConfirmationModal;
